import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  effect,
  ElementRef,
  input,
  viewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { SwiperContainer } from 'swiper/element';
import { Autoplay, Navigation } from 'swiper/modules';

import { AdvertisementListItemDto, CategoryDto } from '../../api';
import { AdvertisementCardComponent } from '../advertisement-card/advertisement-card.component';

@Component({
  selector: 'app-advertisements-carousel',
  imports: [MatButtonModule, MatIconModule, RouterLink, AdvertisementCardComponent, TranslocoDirective],
  templateUrl: './advertisements-carousel.component.html',
  styleUrl: './advertisements-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // Needed for the swiper
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export default class AdvertisementsCarouselComponent {
  swiperContainer = viewChild.required<ElementRef<SwiperContainer>>('swiperContainerElement');
  advertisements = input.required<AdvertisementListItemDto[]>();
  categories = input.required<Map<number, CategoryDto>>();

  constructor() {
    effect(() => {
      const advertisements = this.advertisements();
      if (advertisements.length) {
        const container = this.swiperContainer().nativeElement;
        container.navigation = { nextEl: '#next-business-button', prevEl: '#previous-business-button' };
        container.slidesPerView = 'auto';
        container.centerInsufficientSlides = true;
        container.rewind = true;
        container.autoplay = { delay: 5000, pauseOnMouseEnter: true };
        container.modules = [Autoplay, Navigation];
        container.initialize();
        container.swiper.slidesPerViewDynamic();
      }
    });
  }
}
